import request from '@/utils/request'
import { xlsDownload } from '@/api/view/hip/common/commonXls'

export function epms5070List(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms5070/epms5070List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms5071List(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms5070/epms5071List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms5070Save(param) {
  let data = param
  return request({
    url: `/deliveryControl/epms5070/epms5070Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms5070Xls(param) {
  const data = param
  return request({
    url: `/deliveryControl/epms5070/epms5070Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epms5070XlsRes', res)

    const filename = 'Material List by Invoice.xls'
    xlsDownload(filename, res)
  })
}

export function epms5070XlsNew(param) {
  const data = param
  return request({
    url: `/deliveryControl/epms5070/epms5070XlsNew`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {
    // console.log('epms5070XlsNewRes', res)

    const filename = 'Material by Invoice and Parking List.xls'
    xlsDownload(filename, res)
  })
}